<template>
  <div class="row" v-if="pageLoad">
    <div class="col-xxl-8 order-2 order-xl-1">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-10">
          <ul class="settings-tabs ps-0 mb-0 list-unstyled">
            <li>
              <router-link
                to="/account-settings"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition settings-tab-link"
              >
                {{ $t('settings.personalInfo') }}
              </router-link>
            </li>
            <li>
              <router-link
                to="/settings-change-password"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition settings-tab-link"
              >
                {{ $t('settings.changePassword') }}
              </router-link>
            </li>
            <li>
              <router-link
                to="/settings-organization"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition settings-tab-link"
              >
                {{ $t('settings.editOrganization') }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="canEditOrganization" class="card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <div v-if="errors !== ''" style="margin-top: 5%;">
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId }}</h6>
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors }}</h6>
          </div>
          <div v-if="success !== ''" style="margin-top: 5%;">
            <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success }}</h6>
          </div>

          <form @submit.prevent="updateOrganization">
            <fieldset>
              <div class="row">

                <!-- Champs en lecture seule -->
                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.organizationCode') }}
                    </label>
                    <input
                      v-model="formValues.code"
                      type="text"
                      readonly
                      class="form-control shadow-none rounded-0 text-black bg-light"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.organizationType') }}
                    </label>
                    <input
                      v-model="formValues.type"
                      type="text"
                      readonly
                      class="form-control shadow-none rounded-0 text-black bg-light"
                    />
                  </div>
                </div>

                <!-- Champs modifiables -->
                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.organizationName') }}
                    </label>
                    <input
                      v-model="formValues.name"
                      type="text"
                      class="form-control shadow-none rounded-0 text-black"
                      @blur="validate('name')"
                      @keyup="validate('name')"
                      :class="{ 'is-invalid': errorsBis['name'] }"
                    />
                    <span class="invalid-feedback">{{ errorsBis['name'] }}</span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.email') }}
                    </label>
                    <input
                      v-model="formValues.email"
                      type="email"
                      class="form-control shadow-none rounded-0 text-black"
                      @blur="validate('email')"
                      @keyup="validate('email')"
                      :class="{ 'is-invalid': errorsBis['email'] }"
                    />
                    <span class="invalid-feedback">{{ errorsBis['email'] }}</span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.contact') }}
                    </label>
                    <input
                      v-model="formValues.contact"
                      type="text"
                      class="form-control shadow-none rounded-0 text-black"
                      @blur="validate('contact')"
                      @keyup="validate('contact')"
                      :class="{ 'is-invalid': errorsBis['contact'] }"
                    />
                    <span class="invalid-feedback">{{ errorsBis['contact'] }}</span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.status') }}
                    </label>
                    <select
                      v-model="formValues.status"
                      class="form-control shadow-none rounded-0 text-black"
                      @change="validate('status')"
                      :class="{ 'is-invalid': errorsBis['status'] }"
                    >
                      <option value="ACTIVE">{{ $t('settings.statusActive') }}</option>
                      <option value="INACTIVE">{{ $t('settings.statusInactive') }}</option>
                    </select>
                    <span class="invalid-feedback">{{ errorsBis['status'] }}</span>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.description') }}
                    </label>
                    <textarea
                      v-model="formValues.description"
                      rows="3"
                      class="form-control shadow-none rounded-0 text-black"
                      @blur="validate('description')"
                      @keyup="validate('description')"
                      :class="{ 'is-invalid': errorsBis['description'] }"
                    ></textarea>
                    <span class="invalid-feedback">{{ errorsBis['description'] }}</span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.bankDomiciliation') }}
                    </label>
                    <input
                      v-model="formValues.bankDomiciliation"
                      type="text"
                      class="form-control shadow-none rounded-0 text-black"
                      @blur="validate('bankDomiciliation')"
                      @keyup="validate('bankDomiciliation')"
                      :class="{ 'is-invalid': errorsBis['bankDomiciliation'] }"
                    />
                    <span class="invalid-feedback">{{ errorsBis['bankDomiciliation'] }}</span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.rib') }}
                    </label>
                    <input
                      v-model="formValues.rib"
                      type="text"
                      class="form-control shadow-none rounded-0 text-black"
                      @blur="validate('rib')"
                      @keyup="validate('rib')"
                      :class="{ 'is-invalid': errorsBis['rib'] }"
                    />
                    <span class="invalid-feedback">{{ errorsBis['rib'] }}</span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.cryptoAccount') }}
                    </label>
                    <input
                      v-model="formValues.cryptoAccount"
                      type="text"
                      class="form-control shadow-none rounded-0 text-black"
                      @blur="validate('cryptoAccount')"
                      @keyup="validate('cryptoAccount')"
                      :class="{ 'is-invalid': errorsBis['cryptoAccount'] }"
                    />
                    <span class="invalid-feedback">{{ errorsBis['cryptoAccount'] }}</span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.representativeName') }}
                    </label>
                    <input
                      v-model="formValues.representativeName"
                      type="text"
                      class="form-control shadow-none rounded-0 text-black"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.representativeIdDocs') }}
                    </label>
                    <input
                      v-model="formValues.representativeIdDocs"
                      type="text"
                      class="form-control shadow-none rounded-0 text-black"
                    />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.headOfficeAddress') }}
                    </label>
                    <input
                      v-model="formValues.headOfficeAdress"
                      type="text"
                      class="form-control shadow-none rounded-0 text-black"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.maxPayoutAmount') }}
                    </label>
                    <input
                      v-model.number="formValues.maxPayoutAmount"
                      type="number"
                      class="form-control shadow-none rounded-0 text-black"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.payoutValidationDelay') }}
                    </label>
                    <input
                      v-model.number="formValues.payoutValidationDelay"
                      type="number"
                      class="form-control shadow-none rounded-0 text-black"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25 d-flex align-items-center">
                    <input
                      id="validatePayoutBeforProcess"
                      v-model="formValues.validatePayoutBeforProcess"
                      type="checkbox"
                      class="form-check-input me-10"
                    />
                    <label for="validatePayoutBeforProcess" class="text-black fw-semibold mb-0">
                      {{ $t('settings.validatePayoutBeforProcess') }}
                    </label>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25 d-flex align-items-center">
                    <input
                      id="isTestOrganization"
                      v-model="formValues.isTestOrganization"
                      type="checkbox"
                      class="form-check-input me-10"
                      disabled
                    />
                    <label for="isTestOrganization" class="text-black fw-semibold mb-0">
                      {{ $t('settings.isTestOrganization') }}
                    </label>
                  </div>
                </div>

                <!-- Champs en lecture seule (dates) -->
                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.createdAt') }}
                    </label>
                    <input
                      :value="formatDate(formValues.createdAt)"
                      type="text"
                      readonly
                      class="form-control shadow-none rounded-0 text-black bg-light"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                      {{ $t('settings.updatedAt') }}
                    </label>
                    <input
                      :value="formatDate(formValues.updatedAt)"
                      type="text"
                      readonly
                      class="form-control shadow-none rounded-0 text-black bg-light"
                    />
                  </div>
                </div>

              </div>

              <div class="d-flex align-items-center justify-content-between">
                <button
                  class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                  type="submit"
                  style="background-color: #EB9355;"
                  :disabled="!btnLoad || !isFormValid"
                >
                  <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                  {{ $t('settings.saveChanges') }}
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Loader pendant le chargement -->
  <div v-else class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, inject, computed } from "vue";
import { useI18n } from "vue-i18n";
import * as yup from "yup";
import axios from "axios";
import router from '@/router';
import { checkSessionValidate } from "@/utils/function";

interface Organization {
  code: string;
  name: string;
  description: string | null;
  email: string;
  contact: string | null;
  status: string;
  bankDomiciliation: string | null;
  rib: string | null;
  cryptoAccount: string | null;
  validatePayoutBeforProcess: boolean;
  maxPayoutAmount: number | null;
  payoutValidationDelay: number | null;
  isTestOrganization: boolean;
  type: string | null;
  representativeName: string | null;
  representativeIdDocs: string | null;
  headOfficeAdress: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

const backApi = inject('back');
const { t } = useI18n();

const token: string | null = localStorage.getItem('login_token');
const codeUser: string | null = localStorage.getItem('code');
const role: string | null = localStorage.getItem('role');

// ⭐ Rôles autorisés à modifier l'organisation
const EDIT_ROLES = ['SUPERADMIN', 'BUSINESS', 'SUPPORT', 'ADMIN'];
const canEditOrganization = computed(() => !!role && EDIT_ROLES.includes(role));

const pageLoad = ref(false);
const btnLoad = ref(true);

const errors = ref('');
const errorId = ref('');
const success = ref('');

const errorsBis: Record<string, string> = {
  name: '',
  email: '',
  contact: '',
  status: '',
  description: '',
  bankDomiciliation: '',
  rib: '',
  cryptoAccount: '',
};

const formValues = reactive<Organization>({
  code: '',
  name: '',
  description: '',
  email: '',
  contact: '',
  status: 'ACTIVE',
  bankDomiciliation: '',
  rib: '',
  cryptoAccount: '',
  validatePayoutBeforProcess: false,
  maxPayoutAmount: null,
  payoutValidationDelay: null,
  isTestOrganization: false,
  type: '',
  representativeName: '',
  representativeIdDocs: '',
  headOfficeAdress: '',
  createdAt: null,
  updatedAt: null,
});

// Seuls name / email / status sont réellement obligatoires côté back.
// contact, bankDomiciliation, rib, cryptoAccount peuvent être null (cf. réponse API).
const schema = yup.object({
  name: yup.string().required(t('settings.organizationNameRequired')),
  email: yup.string().required(t('settings.emailRequired')).email(t('settings.emailInvalid')),
  contact: yup.string().nullable(),
  status: yup.string().required(t('settings.statusRequired')),
  description: yup.string().nullable(),
  bankDomiciliation: yup.string().nullable(),
  rib: yup.string().nullable(),
  cryptoAccount: yup.string().nullable(),
});

// Le bouton "Enregistrer" n'est actif que si les champs obligatoires sont valides
const isFormValid = computed(() => {
  return (
    formValues.name.trim().length > 0 &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email) &&
    formValues.status.trim().length > 0
  );
});

function validate(field: keyof typeof errorsBis) {
  // ⭐ Si l'utilisateur n'a pas les droits, on ne valide pas les champs
  if (!canEditOrganization.value) return;

  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch((err) => {
      errorsBis[field] = err.message;
    });
  errors.value = '';
}

function formatDate(value: string | null): string {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return d.toLocaleString();
}

// 1. Récupérer l'utilisateur connecté pour obtenir le code de son organisation
// 2. Récupérer les informations de l'organisation pour préremplir le formulaire
const loadOrganization = () => {
  axios
    .get(backApi + '/secure/users/' + codeUser + '/show', {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((userResponse) => {
      const organizationCode = userResponse.data?.organization?.code;

      if (!organizationCode) {
        errors.value = t('settings.organizationNotFound');
        pageLoad.value = true;
        return;
      }

      axios
        .get(backApi + '/secure/organizations/' + organizationCode + '/show', {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then((orgResponse) => {
          const data = orgResponse.data;
          formValues.code = data.code ?? '';
          formValues.name = data.name ?? '';
          formValues.description = data.description ?? '';
          formValues.email = data.email ?? '';
          formValues.contact = data.contact ?? '';
          formValues.status = data.status ?? 'ACTIVE';
          formValues.bankDomiciliation = data.bankDomiciliation ?? '';
          formValues.rib = data.rib ?? '';
          formValues.cryptoAccount = data.cryptoAccount ?? '';
          formValues.validatePayoutBeforProcess = data.validatePayoutBeforProcess ?? false;
          formValues.maxPayoutAmount = data.maxPayoutAmount ?? null;
          formValues.payoutValidationDelay = data.payoutValidationDelay ?? null;
          formValues.isTestOrganization = data.isTestOrganization ?? false;
          formValues.type = data.type ?? '';
          formValues.representativeName = data.representativeName ?? '';
          formValues.representativeIdDocs = data.representativeIdDocs ?? '';
          formValues.headOfficeAdress = data.headOfficeAdress ?? '';
          formValues.createdAt = data.createdAt ?? null;
          formValues.updatedAt = data.updatedAt ?? null;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              router.push('/');
            } else {
              errorId.value = error.response.data.errorId;
              errors.value = error.response.data.message;
            }
          }
        })
        .finally(() => {
          pageLoad.value = true;
        });
    })
    .catch((error) => {
      pageLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
};

const updateOrganization = async () => {
  // ⭐ Garde-fou : bloque toute soumission si l'utilisateur n'a pas les droits
  if (!canEditOrganization.value) {
    errors.value = t('settings.noEditPermission');
    return;
  }

  try {
    errors.value = '';
    success.value = '';
    btnLoad.value = false;
    await schema.validate(formValues);

    axios
      .put(backApi + '/secure/organizations/' + formValues.code + '/edit', {
        code: formValues.code,
        name: formValues.name,
        description: formValues.description,
        email: formValues.email,
        contact: formValues.contact,
        status: formValues.status,
        bankDomiciliation: formValues.bankDomiciliation,
        rib: formValues.rib,
        cryptoAccount: formValues.cryptoAccount,
        validatePayoutBeforProcess: formValues.validatePayoutBeforProcess,
        maxPayoutAmount: formValues.maxPayoutAmount,
        payoutValidationDelay: formValues.payoutValidationDelay,
        representativeName: formValues.representativeName,
        representativeIdDocs: formValues.representativeIdDocs,
        headOfficeAdress: formValues.headOfficeAdress,
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        btnLoad.value = true;
        if (response.status === 200) {
          success.value = response.data.msg ?? t('settings.organizationUpdated');
        }
      })
      .catch((error) => {
        btnLoad.value = true;
        if (error.response) {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
          if (error.response.status === 401) {
            router.push('/');
          }
        }
      });
  } catch (error) {
    btnLoad.value = true;
    console.error(error);
    errors.value = "une erreur inattendue est apparue";
  }
};

onMounted(() => {
  checkSessionValidate(1);
  loadOrganization();
});
</script>

<style scoped>
.spinner-border {
  width: 3rem;
  height: 3rem;
}

.settings-tab-link {
  color: #7a1f2b;
  padding: 10px 15px;
  border: 1px solid #7a1f2b;
}

.settings-tab-link:hover {
  background-color: #7a1f2b;
  color: #ffffff;
}

.settings-tab-link.router-link-active,
.settings-tab-link.router-link-exact-active {
  background-color: #7a1f2b;
  color: #ffffff;
  border-color: #7a1f2b;
}
</style>